import React, { useEffect, useState } from 'react'
import { Box, Loader, ProfileImage, Table, Text, TextField } from '../../components';
import { Col, Image, Row, Pagination, Tag } from 'antd';
import { ApiCaller, Colors, Constants, Fonts } from '../../config';
import useMedia from 'use-media';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { GiProgression } from "react-icons/gi";
import { FaFlag } from "react-icons/fa6";


const statusMap = {
    0: "Pending",
    1: "Completed",
    2: "Rejected",
    3: "Accepted",
    4: "In-progress",
    5: "Admin Assigned"
};

const BookingManagement = () => {

    const isTablet = useMedia({ minWidth: "768px" });
    const isMobile = useMedia({ minWidth: "550px" });
    const dispatch = useDispatch();
    const navigate = useNavigate();


    const [isUpdate, setIsUpdate] = useState(false);
    const [bookingData, setBookingData] = useState([]);
    const [isLoading, setisloading] = useState(false);
    const [flaggedBooking, setFlaggedBooking] = useState(0)

    const [state, setState] = useState({
        limit: 10,
        offset: 0,
        current: 1,
        search: "",
        status: "",
        total: 0
    });

    useEffect(() => {
        (async () => {
            setisloading(true)
            try {
                let bookings;
                let resp = await ApiCaller.Get(`/admin/bookings?limit=${state?.limit}&offset=${state?.offset}&bookingStatus=${state?.status}`);
                setState({ ...state, total: resp?.data?.data?.count })
                bookings = resp?.data?.data?.bookings;
                setBookingData(bookings);
                setFlaggedBooking(resp?.data?.data?.flaggedCount || 0);
            }
            catch (error) {
                console.log(error)
            }
            finally {
                setisloading(false)
            }
        })()
    }, [isUpdate])


    const handleStatusFilter = (value) => {
        setState({ ...state, current: 1, offset: 0, status: value })
        setIsUpdate(!isUpdate)
    }

    const handlePaginationChange = (page) => {
        const { current, offset, limit } = state;
        const offsetCalc = (page * limit) - limit;
        setState({ ...state, offset: offsetCalc, current: page })
        setIsUpdate(!isUpdate)
    }

    const handleRowClick = (record, index) => {
        navigate(`/booking-detail/${record?.bookingId}`)
    };


    return (
        <Box>
            <Row justify="space-between">
                <Col className="flex-start">
                    <Text.Heading
                        fontSize={24}
                        fontFamily={Fonts["Poppins-SemiBold"]}
                        color={Colors.Black}
                        fontWeight={600}
                        text={<div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                            <h1 className='' style={{ fontSize: '24px', fontWeight: 600 }}>Booking managements</h1>
                            <span style={{ marginBottom: '10px', color: Colors.Danger, display: 'flex', gap: '8px', alignItems: 'center' }}>
                                (
                                {flaggedBooking}
                                <FaFlag color={Colors.Danger} size={18} />
                                )
                            </span>
                        </div>}
                    />
                </Col>
                <Col
                    md={15}
                    sm={isTablet ? 19 : 24}
                    className={isTablet ? "flex-end" : "flex-row-start mt-20"}
                >
                    <Row className={isMobile ? "flex-center" : "flex-column"}>
                        <Col span={12}>
                            <TextField.SelectField
                                placeholder="Select"
                                size="large"
                                id="provider-management-select"
                                type="text"
                                disabled={false}
                                required={false}
                                value={state?.status}
                                label=""
                                defaultValue="All Status"
                                error={false}
                                helperText=""
                                onChange={handleStatusFilter}
                                data={Constants?.bookingStatus}
                            />
                        </Col>
                        {/* <Col span={isMobile ? 14 : 20} className={!isMobile && "mt-5"}>
                            <TextField.CustomInput
                                placeholder="Search"
                                size="large"
                                id="provider-management-search"
                                type="text"
                                disabled={false}
                                required={false}
                                value={state?.search}
                                label=""
                                defaultValue=""
                                error={false}
                                helperText=""
                                onChange={handleSearchUsers}
                                prefix={<HiOutlineSearch color={Colors.dropdownTextColor} />}
                                bgColor={Colors.dropdownBgColor}
                                color={Colors.dropdownTextColor}
                                className="user-search-field"
                            />
                        </Col> */}
                    </Row>
                </Col>
            </Row>
            <Row justify="space-between" className="mt-20">
                <Col span={24}>
                    {
                        isLoading ? (
                            <Col className="user-table-loader-container">
                                <Loader.Circular />
                            </Col>
                        ) :
                            (
                                <>
                                    <Table.AntDesignTable
                                        className="user-table"
                                        onRow={(record, index) => ({
                                            onClick: () => {
                                                handleRowClick(record, index);
                                            },
                                        })}
                                        columns={[
                                            {
                                                title: "Provider Name",
                                                dataIndex: "serviceProvider",
                                                key: "name",
                                                render: (text, record) => (
                                                    <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                                                        <ProfileImage
                                                            src={record?.serviceProvider?.imageUrl}
                                                            alt="user"
                                                            className="service-user-img"
                                                        />
                                                        <span>{record?.serviceProvider?.name ? record?.serviceProvider?.name : 'Not Assigned'}</span>
                                                    </div>
                                                ),

                                            },
                                            {
                                                title: "Email",
                                                dataIndex: "serviceProvider",
                                                key: "email",
                                                render: (text, record) => <span>{record?.serviceProvider?.email ? record?.serviceProvider?.email : 'Not Available'}</span>,

                                            },
                                            {
                                                title: "Location",
                                                dataIndex: "serviceProvider",
                                                key: "location",
                                                render: (text, record) => <span title={record?.serviceProvider?.location ? record?.serviceProvider?.location : 'Not Available'}>{record?.serviceProvider?.location ? record?.serviceProvider?.location?.slice(0, 25) + '...' : 'Not Available'}</span>,
                                            },
                                            {
                                                title: "Phone Num",
                                                dataIndex: "serviceProvider",
                                                key: "phoneNumber",
                                                render: (text, record) => (
                                                    <span>{record?.serviceProvider?.phoneNo ? record?.serviceProvider?.phoneNo : 'Not Available'}</span>
                                                ),
                                            },
                                            {
                                                title: "Booking Type",
                                                dataIndex: "bookingType",
                                                key: "bookingType",
                                                render: (text, record) => (
                                                    <span>{record?.bookingType}</span>
                                                ),
                                            },
                                            {
                                                title: "In-Progress (24h+)",
                                                dataIndex: "isFlaged",
                                                key: "isFlaged",
                                                render: (_, record) => (
                                                    <span>{record?.isDisputed ? <Tag color={"error"} className='m-0'>{'Disputed'}</Tag> : record?.isFlaged ? <FaFlag color={Colors.Danger} size={18} /> : '-'}</span>
                                                ),
                                            },
                                            {
                                                title: "Status",
                                                dataIndex: "bookingStatus",
                                                key: "bookingStatus",
                                                render: (text, record) => (
                                                    <span style={{ padding: '10px', width: '100px', color: '#fff', textAlign: 'center', borderRadius: '10px', background: `${record?.bookingStatus == 0 ? '#FAB700' : record?.bookingStatus == 1 ? '#00B517' : record?.bookingStatus == 2 ? '#a6cdecff' : record?.bookingStatus == 3 ? '#90f5b2ff' : record?.bookingStatus == 4 ? '#3879F0' : '#e74064ff'}` }}>{statusMap[record?.bookingStatus]}</span>)
                                            },
                                        ]}
                                        data={bookingData}
                                        pagination={true}
                                        rowKey="key"
                                        loading={false}
                                    />
                                    <Row justify="center" className="mt-20">
                                        <Col>
                                            <Pagination
                                                responsive="true"
                                                showLessItems="true"
                                                pageSize={10}
                                                current={state?.current}
                                                total={state?.total}
                                                onChange={handlePaginationChange}
                                            />
                                        </Col>
                                    </Row>
                                </>
                            )}
                </Col>
            </Row>
        </Box>
    )
}

export default BookingManagement